import { memo } from 'react';
import { Button, HStack } from '@chakra-ui/react';

import NextImage from 'shared/NextImage';

import LeftAngle from 'assets/icons/leftAngle.svg';
import { DEFAULT_TRANSITION } from 'constants/global';

const SliderControls = ({ slideNext, slidePrev, ...props }) => (
  <HStack gap="8px" hideBelow="laptop" {...props}>
    <IconButton direction="left" id="slider-btn-prev" onClick={slidePrev} />
    <IconButton direction="right" id="slider-btn-next" onClick={slideNext} />
  </HStack>
);

export default memo(SliderControls);

const IconButton = ({ direction, ...props }) => {
  const isLeftButton = direction === 'left';

  return (
    <Button
      role="group"
      boxSize="64px"
      borderRadius="full"
      p="22px"
      bgColor="ourWhite"
      transition={DEFAULT_TRANSITION}
      _hover={{ bgColor: '#FFF2CC' }}
      {...props}
    >
      <NextImage
        w="auto"
        h="full"
        src={LeftAngle}
        alt={`Стрелочка ${isLeftButton ? 'влево' : 'вправо'}`}
        transform={isLeftButton ? 'translateX(-1px)' : 'translateX(1px) rotate(180deg)'}
        transition={DEFAULT_TRANSITION}
      />
    </Button>
  );
};
